import { FC } from "react";
import Loader from "@components/new/Loader/Loader";
import Slider from "@components/Slider/Slider";
import { SLIDER_CONFIG_COLUMNS } from "@components/Slider/Slider.settings";
import useChainNews from "@core/apiHooks/useChainNews";
import useQueryParam from "@core/hooks/useQueryParam";
import { sanitizeUrl } from "@core/helpers";
import { IconDsLogoNewSmall } from "@icons";
import "./NewsCarousel.styles.scss";

const NewsCarousel: FC = () => {
    const chainId = useQueryParam("id");
    const { data, isLoading } = useChainNews(chainId);

    return (
        <div className="NewsCarousel">
            <div className="NewsCarousel__title">News</div>

            <div className="NewsCarousel__content">
                {isLoading && <Loader className="is-no-bg" />}

                {!isLoading && data.length > 0 &&  (
                    <div className="NewsCarousel__slider">
                        <Slider isShownExtraSpace sliderConfig={SLIDER_CONFIG_COLUMNS}>
                            {data.map((item, index) => {
                                const { title, date, url, description, isReportProNews } = item;
                                return (
                                    <div key={index} className="NewsCarouselItem">
                                        <div className="NewsCarouselItem__title">{title}</div>
                                        {isReportProNews && (
                                            <div className="NewsCarouselItem__rp-mark">
                                                <IconDsLogoNewSmall className="NewsCarouselItem__rp-logo" role="img" aria-label="Datassential" />
                                                <div className="NewsCarouselItem__rp-line" aria-hidden="true" />
                                            </div>
                                        )}
                                        <div className="NewsCarouselItem__info">
                                            <div className="NewsCarouselItem__date">{date}</div>
                                            {url && (
                                                <div className="NewsCarouselItem__link">
                                                    <a href={sanitizeUrl(url)} target="_blank" rel="noreferrer">view source</a>
                                                </div>
                                            )}
                                        </div>
                                        <div className="NewsCarouselItem__text">{description}</div>
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                )}

                {data.length === 0 && !isLoading && <div className="NewsCarousel__no-data">No current News updates</div>}
            </div>
        </div>
    );
};

export default NewsCarousel;
